import {ApiRequestError} from "./api-read-retry.ts";

export function isIdempotentEvidenceUpload(path:string,method:string,body:unknown){
  if(method!=="POST" || typeof FormData==="undefined" || !(body instanceof FormData))return false;
  const route=path.split("?")[0];
  return /^\/api\/student\/assessments\/[^/]+\/answers\/[^/]+\/files$/.test(route)
    || /^\/api\/substitute\/student\/sessions\/[^/]+\/submissions\/file$/.test(route);
}

// These routes deduplicate by content hash or submission requestId. Keep the same body on retry.
export async function retryIdempotentEvidenceUpload<T>(operation:()=>Promise<T>,wait:(ms:number)=>Promise<void>=ms=>new Promise(resolve=>setTimeout(resolve,ms))):Promise<T>{
  for(let attempt=0;;attempt++){
    try{return await operation();}
    catch(error){
      const transient=error instanceof TypeError || error instanceof ApiRequestError && [502,503,504].includes(error.status);
      if(!transient || attempt>=2)throw error;
      const delay=error instanceof ApiRequestError && error.status===503?3000:750*(attempt+1);
      await wait(delay+Math.floor(Math.random()*250));
    }
  }
}
